import { ApiBase, HttpMethod } from "../../core/api-base";
import { z } from "zod";
import { DeleteItem200Response, UpdateItem200Response, UpdateItemBody } from "../../api/generated/users.zod";
import { GetHistoryByUser200Response } from "../../api/generated/login_history.zod";

export type UsersAdminPayload = z.infer<typeof UpdateItemBody>;
export type UsersAdminUpdateResponse = z.infer<typeof UpdateItem200Response>;
export type UsersAdminDeleteResponse = z.infer<typeof DeleteItem200Response>;
export type UsersAdminLoginHistoryResponse = z.infer<typeof GetHistoryByUser200Response>;

export type UsersAdminCreateAccountPayload = Record<string, unknown> & {
    email: string;
    nickname: string;
};

export interface UsersAdminCreateAccountResponse {
    success: 0 | 1;
    user?: Record<string, unknown>;
    generated_password?: string;
    message?: string;
    errors?: Record<string, string[]>;
}

export class UsersAdminApi extends ApiBase {
    public static updateUser(userId: number, payload: UsersAdminPayload): Promise<Response> {
        return this.apiRequestWithErrorHandling(
            `/api/v1/users/${encodeURIComponent(String(userId))}`,
            HttpMethod.Put,
            payload,
            {
                showErrors: false,
                fallbackMessage: "master_data_user_update_failed",
            },
        );
    }

    public static getLoginHistoryByUser(userId: number, limit = 20): Promise<Response> {
        return super.apiGet(
            `/api/v1/login-history/user/${encodeURIComponent(String(userId))}?limit=${encodeURIComponent(String(limit))}`,
        );
    }

    public static deleteUser(userId: number): Promise<Response> {
        return super.apiDelete(`/api/v1/users/${encodeURIComponent(String(userId))}`);
    }

    public static createAdminAccount(payload: UsersAdminCreateAccountPayload): Promise<Response> {
        return super.apiPost("/api/v1/users/admin/account", payload);
    }
}
